<script>
    import { user } from "../../../stores";
</script>

<div class="flex flex-col h-full">
    <div class="flex flex-col justify-between items-center">
        <div class="font-bold text-2xl p-5">Welcome {$user.name}</div>
    </div>

    <div class="flex flex-1 flex-col">
        <div class="flex flex-1 flex-col mx-4 mb-4">
            <div class="relative flex-1">
                <div
                    class="flex flex-col overflow-y-auto absolute inset-0 gap-4 mt-4"
                ></div>
            </div>
        </div>
    </div>
</div>
